import React from "react";
import { makeStyles, createStyles, Link } from "@material-ui/core";
import AppLogo from "../../../../public/images/ticketek.svg";
import { IEnvironment } from "../../interface/IShareInfo";

const useStyles = makeStyles(({ breakpoints }) => {
  return createStyles({
    root: {
      backgroundColor: "#001828",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      paddingTop: 13,
      paddingBottom: 11,
      [breakpoints.down("sm")]: {
        paddingTop: 8,
        paddingBottom: 6
      }
    },
    svgIcon: {
      width: "11.1em", // = 111/10
      height: "4.6em", // = 46/10
      fontSize: "1rem", // root font size is 10px
      fill: "white",
      display: "inline-block",
      transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      flexShrink: 0,
      userSelect: "none"
    },
    logo: {
      width: 111,
      height: 46
    }
  });
});

export default (env: IEnvironment) => {
  const classes = useStyles({});
  return (
    <div className={classes.root}>
      <Link
        component="a"
        href={env.HOMEPAGE_URL}
        target="_blank"
        rel="noreferrer"
        variant="h5"
      >
        <AppLogo viewBox="0 0 1920 528.62" className={classes.svgIcon} />
      </Link>
    </div>
  );
};
